const $ = jQuery.noConflict();

class Slider {
	constructor( selector, args = {} ) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		}
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
	}

	init() {
		let settings = this.getSlickSettings();

		$( this.selector ).slick( settings );
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider(
	'.testimonial-slider',
	{
		dots: true,
		dotsClass: 'slick-num-dots',
		customPaging: function (slider, i) {
			return  (i + 1) + '/' + slider.slideCount;
		},
		infinite: false,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true,
				},
			},
		],
	}
);
const TestimonialRepeater = new Slider('.testimonial-repeater');
const QuoteSlider = new Slider(
	'.block-quote-repeater__slider',
	{
		dots: true,
		dotsClass: 'slick-line-dots',
		infinite: true,
		slidesToShow: 3,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
					adaptiveHeight: true,
				},
			},
		],
	}
);
const FluidSlider = new Slider(
	'.gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					centerMode: false,
					variableWidth: false,
				},
			},
		],
	}
);
const InstaSlider = new Slider(
	'.instagram-slider',
	{
		centerMode: true,
		slidesToShow: 3,
		dots:false,
		infinite:true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
				},
			},
			{
			  breakpoint: 575,
			  settings: {
				slidesToShow: 1,
				dots: false,
			  }
			},
		],
	}
);
const CardsSlider = new Slider(
	'.cards-slider',
	{
		centerMode: true,
		variableWidth: true,
		slidesToShow: 1,
		infinite: false,
		responsive: [
			{
			  breakpoint: 575,
			  settings: {
				arrows: false,
				autoplay: true,
				autoplaySpeed: 3000
			  }
			},
		],
	}
);
const BooklpPressQuotes = new Slider(
	'.booklp-press-quotes',
	{
		infinite: false,
		speed: 500,
		asNavFor: '.booklp-press-logos',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true,
				},
			},
		],
	}
);
const BooklpPressLogos = new Slider(
	'.booklp-press-logos',
	{
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		vertical: true,
		focusOnSelect: true,
		asNavFor: '.booklp-press-quotes',
		arrows: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					vertical: false,
					fade: true,
					arrows: false,
					cssEase: 'linear'
				},
			},
		],
	}
);
export { SimpleSlider, TestimonialSlider, TestimonialRepeater, QuoteSlider, FluidSlider, InstaSlider, CardsSlider, BooklpPressQuotes, BooklpPressLogos };
